import { DataGridPremium, frFR, enUS, useGridApiRef, GridToolbar } from '@mui/x-data-grid-premium';
import useJsonStore from '../../services/Hooks/useJsonStore'
import { useEffect, useState } from 'react';
import { getLang } from '../../services/translation';

export default function Grid({id, columns, rows, toolbar, config, aggregate}){

    const apiRef = useGridApiRef();

    const store = useJsonStore();

    const [language, setLanguage] = useState(frFR)

    useEffect(() => {

        setLanguage(getGridLanguage())

        const state = apiRef.current.exportState();

        let defaultState = JSON.parse(JSON.stringify(state));

        defaultState.pagination.paginationModel.pageSize = 10;

        Object.assign(defaultState, config || {});

        let savedState = store.get(id);

        if(savedState){
            Object.assign(defaultState, savedState);
        }

        apiRef.current.restoreState(defaultState);

    }, [store, id, apiRef, config])


    const handleChange = () => {
        const state = apiRef.current.exportState();
        const copy = JSON.parse(JSON.stringify(state));
        copy.preferencePanel.open = false;
        store.set(id, copy);
    }


    return <>

        <DataGridPremium
            apiRef={apiRef}
            rows={rows || []}
            columns={columns}
            pageSizeOptions={[10, 25, 50, 100]}
            autoHeight
            disableRowSelectionOnClick
            loading={!rows}
            localeText={language.components.MuiDataGrid.defaultProps.localeText}
            pagination
            onColumnVisibilityModelChange={handleChange}
            onColumnOrderChange={handleChange}
            onColumnResize={handleChange}
            onColumnWidthChange={handleChange}
            onFilterModelChange={handleChange}
            onPaginationModelChange={handleChange}
            onPinnedColumnsChange={handleChange}
            onSortModelChange={handleChange}
            onDetailPanelExpandedRowIdsChange={handleChange}
            onMenuClose={handleChange}
            onPreferencePanelClose={handleChange}
            onResize={handleChange}
            slots={{toolbar: toolbar && GridToolbar}}
            aggregationModel={aggregate || {}}
        />

    </>
}

const gridLanguages = {
    fr: frFR,
    en: enUS
}

function getGridLanguage(){

    let lang = getLang();

    let gridLanguage = gridLanguages[lang] || frFR;

    return gridLanguage;
}